// extracted by mini-css-extract-plugin
export default {"rating":"cw-z","numberOfStars":"dw-z","count":"ew-z","barGraphSpacing":"fw-z","barGraph":"gw-z"};